<template>
  <v-dialog
    v-model="dialog"
    style="width: calc(100% - 96px)"
    width="calc(100% - 96px)"
    max-width="384px"
    @click:outside="() => {}"
    @keydown.esc="() => {}"
    persistent
  >
    <v-card>
      <v-card-text
        style="
          display: flex;
          flex-direction: column;
          padding: 0px 30px;
          padding-top: 2rem;
          margin: 0;
          text-align: center;
        "
      >
        <img
          @click="stopScan = true"
          src="@/assets/warning.svg"
          class="icon-close"
          :class="{ warn: verifyCount >= 3 }"
          style="
            width: 60px;
            height: 60px;
            margin: 0px auto 18px;
            position:static;
            
          "
        />
        <div class="card-title">본인 인증 실패</div>
        <div v-if="verifyCount < 3" class="card-body">
          입력하신 인증코드가 일치하지 않습니다.<br />확인 후 재시도 해주세요.
        </div>
        <div v-else class="card-body">
          입력코드 입력 횟수가 초과되었습니다.<br />인증코드를 다시 요청
          해주세요.
        </div>
        <div class="card-count" :class="{ warn: verifyCount >= 3 }">
          시도 횟수 : {{ verifyCount }}/3
        </div>
        <div class="button-container" style="margin-bottom: 32px">
          <div @click="ok" class="button cancel">종료</div>
          <div @click="cancel" class="button ok">재시도</div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    verifyCount: {
      type: Number,
    },
  },
  data() {
    return {
      text: 1,
      dialog: this.value,
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit('input', false);
    },
    cancel() {
      if (this.verifyCount >= 3) {
        this.close();
        this.$emit('retry');

        return;
      }

      this.close();
      this.$emit('cancel');
    },
    ok() {
      this.close();
      this.$emit('ok');
    },
  },
};
</script>

<style lang="scss" scoped>
.card-title {
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 2rem;
  color: var(--surface-high);
  margin: 8px;
  margin-top: 0px;
}
.icon-close.warn {
  display: block !important;
}
.card-body {
  /* KR / Body 3 - 16 */

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  line-height: 26px;

  color: var(--surface-high);
  margin: 8px 0px;
}
.card-count {
  /* KR / Body 3 - 16 */

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: var(--surface-medium);
  margin: 8px 0px;
  margin-bottom: 2rem;
  &.warn {
    color: var(--error-100);
  }
}
.button-container {
  display: flex;
  margin-bottom: 39px;

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-weight: 500;
    font-size: 1rem;
    height: 60px;
    cursor: pointer;
    user-select: none;

    &.cancel {
      flex-grow: 0.65;
      background: var(--gray-100);
      color: var(--surface-medium);
      margin-right: 10px;
    }

    &.ok {
      flex-grow: 1;
      color: var(--surface-100);
      background: var(--primary-100);
    }
  }
}
</style>
